module.exports = "../dist/img/img_4-26.cf10.jpg";